import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


const STATUS_COLORS = {
  DRAFT: 'bg-gray-100 text-gray-800', RECEIVED: 'bg-blue-100 text-blue-800',
  PAID: 'bg-green-100 text-green-800', VOID: 'bg-red-100 text-red-800', OVERDUE: 'bg-orange-100 text-orange-800',
};

export default function Bills() {
  const [bills, setBills] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');

  useEffect(() => {
    const url = filterStatus ? `/bills?status=${filterStatus}` : `/bills`;
    api(url).then(r => r.json()).then(setBills).catch(() => {});
  }, [filterStatus]);

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Bills</h1>
            <Link to="/accounting/bills/new" className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700">New Bill</Link>
          </div>
          <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600">
            <option value="">All Statuses</option>
            <option value="DRAFT">Draft</option>
            <option value="RECEIVED">Received</option>
            <option value="PAID">Paid</option>
            <option value="OVERDUE">Overdue</option>
            <option value="VOID">Void</option>
          </select>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Bill #</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Vendor</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Due Date</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Total</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {bills.map((b) => (
                <tr key={b.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap font-medium"><Link to={`/accounting/bills/${b.id}`} className="text-emerald-600 hover:text-emerald-800">{b.billNumber}</Link></td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">{b.companyName || b.contactName || '—'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-900">{b.dueDate}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-right font-semibold text-gray-900">${(b.total || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                  <td className="px-6 py-4 whitespace-nowrap"><span className={`px-3 py-1 rounded-full text-sm font-medium ${STATUS_COLORS[b.status] || 'bg-gray-100 text-gray-800'}`}>{b.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          {bills.length === 0 && <div className="text-center py-12 text-gray-500">No bills found.</div>}
        </div>
      </div>
    </Layout>
  );
}
